export const SHOW_ITEMS = {
  TRASH: 'TRASH',
  DISPLAY: 'DISPLAY',
};

// possible included keywords
export const SEARCH_KEYWORDS = [
  { name: 'status', value: 'status:' },
  { name: 'priority', value: 'priority:' },
  { name: 'description', value: 'description:' },
  { name: 'title', value: 'title:' },
  { name: 'type', value: 'type:' },
  { name: 'isDescendentOf', value: 'isdescendentof:' },
  { name: 'id', value: 'id:' },
  { name: 'tags', value: '#' },
];

export const FILE_TYPES = {
  Image: 'image/',
  Pdf: 'application/pdf',
  Docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // Maximum file size user can upload